var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerAndClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    d: "M1.60714 42.375H43.3929C44.2805 42.375 45 41.6555 45 40.7678V36.75C45 35.8623 44.2805 35.1428 43.3929 35.1428H1.60714C0.719498 35.1428 0 35.8623 0 36.75V40.7678C0 41.6555 0.719498 42.375 1.60714 42.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mid",
    d: "M1.60714 26.3037H43.3929C44.2805 26.3037 45 25.5842 45 24.6965V20.6787C45 19.791 44.2805 19.0715 43.3929 19.0715H1.60714C0.719498 19.0715 0 19.791 0 20.6787V24.6965C0 25.5842 0.719498 26.3037 1.60714 26.3037Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "top",
    d: "M1.60714 10.2321H43.3929C44.2805 10.2321 45 9.51265 45 8.625V4.60714C45 3.7195 44.2805 3 43.3929 3H1.60714C0.719498 3 0 3.7195 0 4.60714V8.625C0 9.51265 0.719498 10.2321 1.60714 10.2321Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerAndClose);
export default __webpack_public_path__ + "static/media/hamburger-and-close.d99da0b9588687938933abe81c2ef6b3.svg";
export { ForwardRef as ReactComponent };